import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import UrithiNormalAssets from '../components/UrithiNormalAssets';
import UrithiDummyAssets from '../components/UrithiDummyAssets';
import UrithiPurchases from '../components/UrithiPurchases';
import UrithiMonthlyServices from '../components/UrithiMonthlyServices';
import UrithiSettings from '../components/UrithiSettings';
import {
  Package, ShoppingBag, PackageOpen, RotateCcw, ChevronRight, Home, Settings,
} from 'lucide-react';

const urithiTabs = [
  { label: 'Normal Assets', icon: Package,     description: 'Manage installment-based mobile & immobile assets', content: <UrithiNormalAssets /> },
  { label: 'Products',      icon: PackageOpen, description: 'Tradable products available for one-off purchase',  content: <UrithiDummyAssets /> },
  { label: 'Bill Services', icon: RotateCcw,   description: 'Monthly recurring service subscriptions',           content: <UrithiMonthlyServices /> },
  { label: 'Orders',        icon: ShoppingBag, description: 'All purchases and order history',                   content: <UrithiPurchases /> },
  { label: 'Settings',      icon: Settings,    description: 'Manage asset categories and quantity units',        content: <UrithiSettings /> },
];

function Urithi() {
  const [selectedTab, setSelectedTab] = useState(0);
  const Active = urithiTabs[selectedTab];
  const ActiveIcon = Active.icon;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-100">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-12">
            <nav className="flex items-center gap-2 text-xs">
              <Link to="/" className="text-gray-500 hover:text-[#001f3f] transition-colors font-medium">Home</Link>
              <ChevronRight className="w-3 h-3 text-gray-400" />
              <span className="font-bold text-[#001f3f] uppercase tracking-wide">Urithi</span>
            </nav>
          </div>
        </div>
      </div>

      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Hero banner */}
        <div className="bg-[#001f3f] rounded-2xl p-6 mb-5">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-14 h-14 rounded-full flex items-center justify-center border bg-[rgba(201,152,42,0.18)] border-[rgba(201,152,42,0.35)]">
              <Home className="w-7 h-7 text-[#C9982A]" />
            </div>
            <div className="flex-1">
              <p className="text-[10px] text-[#C9982A] font-bold tracking-[0.2em] mb-1">URITHI PLATFORM</p>
              <h1 className="text-2xl font-black text-white">Heritage Marketplace</h1>
            </div>
          </div>
          <div className="h-px bg-white/10 mb-3" />
          <p className="text-xs text-white/60 leading-relaxed">
            Manage mobile &amp; immobile assets, tradable products, monthly service subscriptions, and customer orders — all from one place.
          </p>
        </div>

        {/* Tab card */}
        <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
          <div className="border-b border-gray-100 bg-gray-50/50">
            <div className="flex overflow-x-auto">
              {urithiTabs.map((tab, idx) => {
                const TabIcon = tab.icon;
                const isActive = selectedTab === idx;
                return (
                  <button
                    key={tab.label}
                    onClick={() => setSelectedTab(idx)}
                    className={`relative flex items-center gap-2.5 px-5 py-4 text-sm font-semibold whitespace-nowrap transition-all duration-200 min-w-fit ${
                      isActive ? 'text-[#001f3f] bg-white' : 'text-gray-500 hover:text-[#001f3f] hover:bg-white/50'
                    }`}
                  >
                    <div className={`p-1.5 rounded-lg transition-colors ${isActive ? 'bg-[#001f3f] text-white' : 'bg-gray-200 text-gray-600'}`}>
                      <TabIcon className="w-4 h-4" />
                    </div>
                    <span className="text-xs uppercase tracking-wide">{tab.label}</span>
                    {isActive && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#001f3f]" />}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="px-6 py-4 bg-white border-b border-gray-100">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-[#001f3f]/10 flex items-center justify-center">
                <ActiveIcon className="w-4 h-4 text-[#001f3f]" />
              </div>
              <div>
                <h2 className="text-sm font-bold text-[#001f3f] uppercase tracking-wide">{Active.label}</h2>
                <p className="text-xs text-gray-500 mt-0.5">{Active.description}</p>
              </div>
            </div>
          </div>

          <div className="p-4 sm:p-6 bg-gray-50/50 min-h-[500px]">
            {Active.content}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Urithi;